<template>
  <div>
    <div class="control-section">
      <div class="sample-container">
        <div class="default-section">
          <ejs-richtexteditor
            ref="rteObj"
            :height="200"
            :toolbarSettings="toolbarSettings"
            :quickToolbarSettings="quickToolbarSettings"
            :created="onCreated"
            v-model.trim="text"
            :showCharCount="showCharCount"
            :maxLength="maxLength"
            :actionBegin="actionBegin"
            :beforeDialogClose="beforeDialogClose"
            :toolbarClick="toolbarClick"
            :locale="locale"
            :saveInterval="10"
            :readonly="editorReadonly"
            :blur="checkImage"
            :focus="checkImage"
            :change="checkImage"
            :afterPasteCleanup="afterPasteCleanup"
          ></ejs-richtexteditor>
          <div v-if="isImagePresent">
            <span
              v-if="section === 'convocation' && isImageAllowed"
              style="color: var(--v-error-base) !important"
              >{{ $t("imagePasteNotAllowed") }}</span
            >
            <span
              v-else-if="section === 'remindVotingConsent'"
              style="color: var(--v-error-base) !important"
              >{{ $t("imagePasteNotAllowedRemindVotingConsent") }}</span
            >
            <span v-else style="color: var(--v-error-base) !important">{{
              $t("imageNotAllowed")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Count,
  HtmlEditor,
  QuickToolbar,
  Resize,
  Image,
  PasteCleanup,
} from "@syncfusion/ej2-vue-richtexteditor";
import { L10n } from "@syncfusion/ej2-base";
Vue.use(RichTextEditorPlugin);
import * as localeText from "@/Langs/locale.json";
L10n.load(localeText.default);
export default {
  name: "ARichTextEditor",
  props: {
    value: {
      type: String,
      default: "",
    },
    tools: {
      type: Array,
      default: () => [],
    },
    editorReadonly: {
      type: Boolean,
      default: false,
    },
    isImageAllowed: {
      type: Boolean,
      default: false,
    },
    enable: {
      type: Boolean,
      default: true,
    },
    section: {
      type: String,
    },
  },
  data() {
    return {
      pasteCleanupSettings: {
        prompt: false,
        deniedAttrs: null,
        allowedStyleProps: [
          "background",
          "background-color",
          "border",
          "border-bottom",
          "border-width",
          "clear",
          "visibility",
          "white-space",
          "width",
        ],
        deniedTags: null,
        keepFormat: true,
        plainText: false,
      },
      isImagePresent: null,
      showCharCount: true,
      maxLength: 10000,
      quickToolbarSettings: {
        table: [
          "TableHeader",
          "TableRows",
          "TableColumns",
          "TableCell",
          "-",
          "BackgroundColor",
          "TableRemove",
          "TableCellVerticalAlign",
          "Styles",
        ],
      },
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value ? value : "");
      },
    },
    toolbarSettings() {
      return {
        enable: this.enable,
        type: "Expand",
        items: [
          "Bold",
          "Italic",
          "Underline",
          "StrikeThrough",
          "FontName",
          "FontSize",
          "FontColor",
          "BackgroundColor",
          "LowerCase",
          "UpperCase",
          "|",
          "Formats",
          "Alignments",
          "OrderedList",
          "UnorderedList",
          "Outdent",
          "Indent",
          "|",
          ...this.tools,
          "ClearFormat",
          "Undo",
          "Redo",
        ],
      };
    },
  },
  mounted() {
    if (!this.isImageAllowed) {
      this.isImagePresent = this.text.includes("<img src=");
    }
  },
  provide: {
    richtexteditor: [
      Toolbar,
      Link,
      Count,
      HtmlEditor,
      QuickToolbar,
      Resize,
      Image,
      PasteCleanup,
    ],
  },
  watch: {
    isImagePresent(val) {
      this.$emit("descriptionChange", val);
    },
  },
  methods: {
    onCreated,
    actionBegin,
    beforeDialogClose,
    async afterPasteCleanup(args) {
      const pastedText = await navigator.clipboard.readText();
      const fileUrlPattern = /(https?:\/\/[^\s]+\/([^\s?#]+)(\?[^#]*)?(#.*)?)/i;
      const match = pastedText.match(fileUrlPattern);
      if (match) {
        const url = match[1];
        if (url.includes("/download/")) {
          const fileUrl = url.substring(0, url.lastIndexOf("/"));
          const fileName = url.split("/").pop().split("?")[0];
          const anchorHTML = `<a href="${fileUrl}" target="_blank" rel="noopener noreferrer">${decodeURI(
            fileName
          )}</a>`;

          this.$refs.rteObj.executeCommand("insertHTML", anchorHTML);
          this.removeSpecificUrl(url);
        }
      }
    },
    removeSpecificUrl(urlToRemove) {
      const rte = this.$refs.rteObj;
      const editor = rte.getContent();
      const anchorTags = editor.querySelectorAll("a");

      anchorTags.forEach((anchor) => {
        const anchorText = anchor.textContent.trim();
        if (anchorText === urlToRemove) {
          anchor.remove();
        }
      });
    },
    checkImage() {
      if (this.section === "convocation" && this.isImageAllowed) {
        this.isImagePresent = this.text.includes(`<img src="blob:`);
      } else if (!this.isImageAllowed) {
        this.isImagePresent = this.text.includes("<img src=");
      }
    },
    toolbarClick(e) {
      if (e.item && e.item.subCommand == "CreateLink") {
        const footer = document.querySelector(
          ".e-rte-link-dialog .e-footer-content"
        );
        setTimeout(() => {
          if (footer && footer.children) {
            for (var i = 0; i < footer.children.length; i++) {
              if (footer.children[i].textContent) {
                footer.children[i].title = footer.children[i].textContent;
              }
            }
          }
        }, 200);
      }
    },
  },
};

function onCreated() {
  setTimeout(() => {
    if (this.$refs.rteObj) {
      this.$refs.rteObj.refreshUI();
    }
  }, 10);
}

function actionBegin(e) {
  if (e.requestType === "CreateLink" || e.requestType === "EditLink") {
    const str = e.itemCollection.url;
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // validate protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // validate fragment locator
    const urlValid = !!urlPattern.test(str);
    if (urlValid) {
      e.cancel = false;
    } else {
      e.cancel = true;
      e.originalEvent.stopPropagation();
      return false;
    }
  }
}

function beforeDialogClose(e) {
  if (
    e.element.getElementsByClassName("e-rte-linkurl").length > 0 &&
    !e.event.returnValue
  ) {
    const inputEml = e.element.getElementsByClassName("e-rte-linkurl")[0];
    const url = inputEml.value;
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // validate protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // validate fragment locator
    const urlValid = !!urlPattern.test(url);
    if (!urlValid) {
      inputEml.classList.add("e-error");
      if (e.element.getElementsByClassName("url-input-error").length > 0) {
        e.element.getElementsByClassName("url-input-error")[0].remove();
      }
      let html = `<div class="url-input-error">${this.$t(
        "agenda.validUrl"
      )}</div>`;
      inputEml.insertAdjacentHTML("afterend", html);
      e.cancel = true;
      return false;
    } else {
      inputEml.classList.remove("e-error");
      if (e.element.getElementsByClassName("url-input-error").length > 0) {
        e.element.getElementsByClassName("url-input-error")[0].remove();
      }
      e.cancel = false;
      return true;
    }
  }
}
</script>

<style scoped>
::v-deep .e-rte-link-dialog .e-dlg-header-content,
::v-deep .e-rte-edit-table .e-dlg-header-content,
::v-deep .e-rte-img-dialog .e-dlg-header-content {
  background-color: var(--v-primaryLight1-base) !important;
  border-color: var(--v-primaryLight1-base) !important;
  /* padding-top: 10px; */
  /* padding: 4px 16px; */
  /* height: 48px; */
  padding-top: 9px;
  padding-bottom: 9px;
  margin-bottom: 20px;
}

::v-deep .e-rte-link-dialog .e-dlg-header-content .e-dlg-header,
::v-deep .e-rte-edit-table .e-dlg-header-content .e-dlg-header,
::v-deep .e-rte-img-dialog .e-dlg-header-content .e-dlg-header {
  color: var(--v-darkCharcoal-base) !important;
  font-family: "Noto Sans JP" !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

::v-deep .e-rte-link-dialog .e-footer-content .e-btn,
::v-deep .e-rte-edit-table .e-footer-content .e-btn,
::v-deep .e-rte-img-dialog .e-footer-content .e-btn {
  height: 36px;
  min-width: 64px;
  padding: 0 16px;
  background-color: var(--v-secondary-base) !important;
  border-color: var(--v-secondary-base) !important;
  color: var(--v-darkCharcoal-base) !important;
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 500;
  font-family: "Noto Sans JP" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  text-transform: initial !important;
}

::v-deep .e-rte-link-dialog .e-footer-content .e-btn.e-primary,
::v-deep .e-rte-edit-table .e-footer-content .e-btn.e-primary,
::v-deep .e-rte-img-dialog .e-footer-content .e-btn.e-primary {
  background-color: var(--v-primaryDark-base) !important;
  border-color: var(--v-primaryDark-base) !important;
  color: white !important;
}
::v-deep .e-checkbox-wrapper .e-checkbox:active + .e-frame.e-check {
  background-color: var(--v-primary-base) !important;
}

::v-deep .e-checkbox-wrapper .e-checkbox:focus + .e-frame.e-check {
  background-color: var(--v-primary-base) !important;
}
::v-deep .e-checkbox-wrapper .e-frame.e-check {
  background-color: var(--v-primary-base) !important;
}

.fabric-dark .cm-s-default .cm-tag,
.bootstrap5-dark .cm-s-default .cm-tag,
.material-dark .cm-s-default .cm-tag,
.tailwind-dark .cm-s-default .cm-tag,
.highcontrast .cm-s-default .cm-tag {
  color: #00ff00;
}

.fabric-dark .cm-s-default .cm-string,
.bootstrap5-dark .cm-s-default .cm-string,
.material-dark .cm-s-default .cm-string,
.tailwind-dark .cm-s-default .cm-string {
  color: blue;
}

.highcontrast .cm-s-default .cm-string {
  color: #ffd939;
}

.fabric-dark .cm-s-default .cm-attribute,
.bootstrap5-dark .cm-s-default .cm-attribute,
.material-dark .cm-s-default .cm-attribute,
.tailwind-dark .cm-s-default .cm-attribute,
.highcontrast .cm-s-default .cm-attribute {
  color: #f00;
}

.fabric-dark .CodeMirror,
.bootstrap5-dark .CodeMirror,
.material-dark .CodeMirror,
.tailwind-dark .CodeMirror {
  background: #303030;
  color: white;
}

.highcontrast .CodeMirror {
  background: black;
  color: white;
}

.e-richtexteditor {
  color: #333;
  display: block;
  position: relative;
  /* z-index: 0; */
}
.e-richtexteditor .e-rte-content .e-content pre {
  padding: 10px;
  background: #f4f5f7;
}

.fabric-dark .e-richtexteditor .e-rte-content .e-content pre,
.bootstrap5-dark .e-richtexteditor .e-rte-content .e-content pre,
.material-dark .e-richtexteditor .e-rte-content .e-content pre,
.tailwind-dark .e-richtexteditor .e-rte-content .e-content pre,
.highcontrast .e-richtexteditor .e-rte-content .e-content pre {
  padding: 10px;
  background: #303030;
}
::v-deep .url-input-error {
  color: red;
}
</style>